// Scroll to top after changing pagination page on the wishlist page (more than 8 wishlist items)
document.addEventListener("click", (event) => {
  const isPaginationBtn = event.target.closest("button.xb-pagination__button, button.xb-pagination__page");

  if (isPaginationBtn) {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 300);
  }
});

// Reformatting price tags on the wishlist page
(function () {
  const formatTextNodes = (node) => {
    if (node.nodeType === 3) {
      const text = node.nodeValue;
      if (text.includes('CHF') || text.includes('.00')) {
        node.nodeValue = text.replace(/CHF\s*/g, '').replace(/\.00/g, '.–');
      }
    } else if (node.nodeType === 1) {
      node.childNodes.forEach(formatTextNodes);
    }
  };

  const formatPrices = () => {
    const priceElements = document.querySelectorAll('.xb-wishlist-product__style-2-price');
    priceElements.forEach(formatTextNodes);
  };

  const observer = new MutationObserver(formatPrices);
  observer.observe(document.body, { childList: true, subtree: true });

  formatPrices();
})();